import moment from 'moment';

export function isNumeric(x) {
  return !isNaN(x) &&
    typeof x !== 'object' &&
    x != Number.POSITIVE_INFINITY &&
    x != Number.NEGATIVE_INFINITY;
}

export function getInputNameAttributeString(fieldName) {
  return `[name='${fieldName.replace(/([\'])/g, '\\$1')}']`;
}

export function validateNRIC(str) {
  if (str.length !== 9) return false;

  str = str.toUpperCase();

  let i,
    icArray = [];
  for (i = 0; i < 9; i++) {
    icArray[i] = str.charAt(i);
  }

  icArray[1] = parseInt(icArray[1], 10) * 2;
  icArray[2] = parseInt(icArray[2], 10) * 7;
  icArray[3] = parseInt(icArray[3], 10) * 6;
  icArray[4] = parseInt(icArray[4], 10) * 5;
  icArray[5] = parseInt(icArray[5], 10) * 4;
  icArray[6] = parseInt(icArray[6], 10) * 3;
  icArray[7] = parseInt(icArray[7], 10) * 2;

  let weight = 0;
  for (i = 1; i < 8; i++) {
    weight += icArray[i];
  }

  const offset = icArray[0] == 'T' || icArray[0] == 'G' ? 4 : 0;
  const temp = (offset + weight) % 11;

  const st = ['J', 'Z', 'I', 'H', 'G', 'F', 'E', 'D', 'C', 'B', 'A'];
  const fg = ['X', 'W', 'U', 'T', 'R', 'Q', 'P', 'N', 'M', 'L', 'K'];

  let theAlpha;
  if (icArray[0] == 'S' || icArray[0] == 'T') {
    theAlpha = st[temp];
  } else if (icArray[0] == 'F' || icArray[0] == 'G') {
    theAlpha = fg[temp];
  }

  return icArray[8] === theAlpha;
}

// validateEmail() https://stackoverflow.com/a/46181
export function validateEmail(email) {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

export function autoLink(text) {
  (function () {
    const k = [].slice; String.prototype.autoLink = function () {
      let d,
        b,
        g,
        a,
        e,
        f,
        h; e = arguments.length >= 1 ? k.call(arguments, 0) : []; f = /(^|[\s\n]|<[A-Za-z]*\/?>)((?:https?|ftp):\/\/[\-A-Z0-9+\u0026\u2019@#\/%?=()~_|!:,.;]*[\-A-Z0-9+\u0026@#\/%=~()_|])/gi; if (!(e.length > 0)) return this.replace(f, "$1<a href='$2'>$2</a>"); a = e[0]; d = a.callback; g = (function () { let c; c = []; for (b in a)h = a[b], b !== 'callback' && c.push(` ${b}='${h}'`); return c; }()).join(''); return this.replace(f, (c, b, a) => { c = (typeof d === 'function' ? d(a) : void 0) || `<a href='${a}'${g}>${a}</a>`; return `${b}${c}`; });
    };
  }).call(this);
  if (text === null || text === undefined) return '';
  if (text.length === 0) return '';
  return text.autoLink({ target: '_blank' });
}

// Returns the first Zoom meeting URL found in a block of text, or '' if none.
// Matches zoom.us, subdomains (e.g. us02web.zoom.us), zoom.com and zoomgov.com.
export function extractZoomLink(text) {
  if (!text) return '';
  const match = String(text).match(
    /https?:\/\/(?:[a-z0-9-]+\.)*zoom(?:gov)?\.(?:us|com)\/[^\s<"')]+/i,
  );
  if (!match) return '';
  return match[0].replace(/[.,;]+$/, ''); // strip trailing sentence punctuation
}

export function uniq(a) {
  let prims = { boolean: {}, number: {}, string: {} },
    objs = [];

  return a.filter((item) => {
    const type = typeof item;
    if (type in prims) { return prims[type].hasOwnProperty(item) ? false : (prims[type][item] = true); }
    return objs.indexOf(item) >= 0 ? false : objs.push(item);
  });
}

export function getRegularExpression(countryCode, identityType, stateCode, identityConfig) {
  const countryInfoFound = identityConfig.identity_regexes.filter(countryInfo => countryInfo.country_code === countryCode)[0];
  if (!countryInfoFound) return undefined;

  const identityInfoFound = countryInfoFound.identity_types.filter(identityInfo => identityInfo.value === identityType)[0];
  if (!identityInfoFound) return undefined;

  // No state means there is no one more level nested (eg: none drive license identity type)
  if (stateCode === undefined) return identityInfoFound.regex;

  const stateInfoFound = identityInfoFound.states.filter(stateInfo => stateInfo.state_code === stateCode)[0];

  if (!stateInfoFound) return undefined;

  return stateInfoFound.regex;
}

export function toFormData(obj, form, namespace) {
  const fd = form || new window.FormData();
  let formKey;

  for (const property in obj) {
    // 当属性为空字符串时，也需要传参数进入
    if (obj.hasOwnProperty(property) && obj[property] !== undefined) {
      if (namespace) {
        formKey = `${namespace}[${property}]`;
      } else {
        formKey = property;
      }

      // if the property is an object, but not a File, use recursivity.
      if (obj[property] instanceof Date) {
        fd.append(formKey, obj[property].toISOString());
      } else if (obj[property] instanceof Array) {
        // fd.append(formKey, obj[property]);
        if (obj[property].length === 0) {
          fd.append(`${formKey}[]`, '');
        } else {
          obj[property].forEach((value) => {
            if (typeof value === 'object') {
              toFormData(value, fd, `${formKey}[]`);
            } else {
              fd.append(`${formKey}[]`, value);
            }
          });
        }
      } else if (typeof obj[property] === 'object' && !(obj[property] instanceof window.File)) {
        toFormData(obj[property], fd, formKey);
      } else {
        // if it's a string or a File object
        if (/^\s*$/.test(obj[property])) {
          fd.append(formKey, '');
        } else {
          fd.append(formKey, obj[property]);
        }
      }
    }
  }

  return fd;
}

export function capitializeString(string) {
  if (!string) return '';
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export const humanReadableDateString = (text) => {
  let result = moment(text).format('MMM D, YYYY');
  const isSameYear = moment().isSame(text, 'year');
  const isSameDay = moment().isSame(text, 'day');
  if (isSameYear) {
    // E.g. Jan 14
    result = moment(text).format('MMM D');
  }
  if (isSameDay) {
    result = `Today ${moment(text).format('h:mm A')}`;
  }
  return result;
};

export const getErrorMessage = (value, rules) => {
  // Replace all the start white spaces to prevent by-passing the
  // required fields only with white space value like '  '
  // We only operate on string value for now
  if (typeof value === "string") {
    value = value.replace(/^\s*/g, "");
  }
  if (value === "" || value === null || value === undefined)
    return "This is a mandatory field.";
  // multiple_selection has empty array as default empty value,
  // need to check array length
  if (value.length === 0) return "This is a mandatory field.";
  if (!rules || rules.length === 0 || rules[0] === null) return undefined;
  let message = undefined;
  for (let i = 0; i < rules.length; i++) {
    const rule = rules[i];
    const {
      category: categoryValue,
      action: actionValue,
      value: ruleValue,
      customErrorMessage
    } = rule;
    if (categoryValue === "number") {
      if (!isNumeric(value)) {
        message = "Please enter a valid number";
        break;
      } else if (actionValue === "gte" && Number(value) < ruleValue) {
        message = `Please enter a number greater than or equal to ${ruleValue}`;
        break;
      } else if (actionValue === "lte" && Number(value) > ruleValue) {
        message = `Please enter a number less than or equal to ${ruleValue}`;
      } else if (rule.gte || rule.lte) {
        if (Number(value) < rule.gte) {
          message = `Please enter a number greater than or equal to ${rule.gte}`;
          break;
        } else if (Number(value) > rule.lte) {
          message = `Please enter a number less than or equal to ${rule.lte}`;
          break;
        }
      }
    } else if (categoryValue === "length") {
      if (actionValue === "min" && value.length < ruleValue) {
        message = `Your response is too short. The minimum character limit is ${ruleValue}`;
        break;
      }
      if (actionValue === "max" && value.length > ruleValue) {
        message = `Your response is too long. The maximum character limit is ${ruleValue}`;
        break;
      }
    }
    if (categoryValue === "regex") {
      if (actionValue === "match" && !new RegExp(ruleValue).test(value)) {
        message = customErrorMessage ? customErrorMessage : "Please enter a valid response";
        break;
      }
      if (actionValue === "unmatch" && new RegExp(ruleValue).test(value)) {
        message = customErrorMessage? customErrorMessage : "Please enter a valid response";
        break;
      }
    } else if (categoryValue === "date") {
      const userInputDate = new Date(value);
      const ruleDateValue = new Date(ruleValue);
      const ruleDateMin = new Date(rule.min);
      const ruleDateMax = new Date(rule.max);
      if (actionValue === "lt" && userInputDate >= ruleDateValue) {
        message = `Please enter a date before ${ruleValue}`;
        break;
      } else if (actionValue === "lte" && userInputDate > ruleDateValue) {
        message = `Please enter a date on or before ${ruleValue}`;
        break;
      } else if (actionValue === "gt" && userInputDate <= ruleDateValue) {
        message = `Please enter a date after ${ruleValue}`;
        break;
      } else if (actionValue === "gte" && userInputDate < ruleDateValue) {
        message = `Please enter a date on or after ${ruleValue}`;
        break;
      } else if (
        actionValue === "between" &&
        (userInputDate < ruleDateMin || userInputDate > ruleDateMax)
      ) {
        message = `Please enter a date on or between ${rule.min} and ${rule.max}`;
        break;
      } else if (
        actionValue === "unbetween" &&
        (userInputDate <= ruleDateMin || userInputDate >= ruleDateMax)
      ) {
        message = `Please enter a date between ${rule.min} and ${rule.max}`;
        break;
      }
    }
  }
  return message;
};

export const replaceUnderscore = (value) => {
  if (!value) return '';
  return value.replaceAll('_', ' ');
};
